/**
 * @Directive
 * Gives focus to a form element which has the focus attribute
 *
 */

import { Directive, ElementRef, AfterViewInit, Input, OnChanges, HostListener } from '@angular/core';

@Directive({
  selector: '[focus]'
})

export class ElementFocusDirective {

  // Property that determines focus state
  @Input('focus') hasFocus: boolean;
  // Reset property to false once focused
  @HostListener('focus') onFocus() {
    this.hasFocus = false;
  }

  constructor(
    private elementRef: ElementRef
  ) {}


  /**
   * Focus element after view displayed if property set to true
   *
	 * @return		void
   */
  ngAfterViewInit(): void {
    if(this.hasFocus)
      this.elementRef.nativeElement.focus();
  }

  /**
   * Focus element whenever hasFocus property changes and is set to true
   *
   * @param		  {Object}   Object of changes that just happened
   * @return		void
   */
  ngOnChanges(changes: any): void {
    if(changes.hasFocus && changes.hasFocus.currentValue === true)
      this.elementRef.nativeElement.focus();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/element-focus.directive.ts